import { IFilterAngularComp } from 'ag-grid-angular';
import { IDoesFilterPassParams, IFilterParams } from 'ag-grid-community';
import { Component } from '@angular/core';

@Component({
    standalone: false,
    template: `
        <div class="radio-filter">
            <div class="radio-filter-label">{{ 'HOME_COMPONENTS.AG_GRID.SHOW' | translate }}:</div>
            <div class="radio-filter-container">
                <label class="radio-filter-input">
                    <input type="radio" name="selectedState" [(ngModel)]="selectedState" (ngModelChange)="updateFilter()" [value]="'All'" />
                    {{ 'HOME_COMPONENTS.AG_GRID.ALL' | translate }}
                </label>

                <label class="radio-filter-input">
                    <input type="radio" name="selectedState" [(ngModel)]="selectedState" (ngModelChange)="updateFilter()" [value]="'Selected'" />
                    {{ 'HOME_COMPONENTS.AG_GRID.SELECTED' | translate }}
                </label>

                <label class="radio-filter-input">
                    <input type="radio" name="selectedState" [(ngModel)]="selectedState" (ngModelChange)="updateFilter()" [value]="'UnSelected'" />
                    {{ 'HOME_COMPONENTS.AG_GRID.UNSELECTED' | translate }}
                </label>
            </div>
        </div>
    `,
    styleUrls: ['./selected-filter.scss']
})
export class SelectedRowsFilter implements IFilterAngularComp {
    params!: IFilterParams;
    selectedState = 'All';

    agInit(params: IFilterParams): void {
        this.params = params;
    }

    isFilterActive(): boolean {
        return this.selectedState !== 'All';
    }

    doesFilterPass(params: IDoesFilterPassParams): boolean {
      let isValid:boolean = true; // default or for all
      if(this.selectedState === 'Selected') { isValid = params.node.isSelected(); }
      if(this.selectedState === 'UnSelected') { isValid = !params.node.isSelected(); }
      return isValid; 
    }

    getModel() {}

    setModel(model: any) {}

    updateFilter() {
      this.params.filterChangedCallback();
    }
}
